export default __webpack_public_path__ + "static/media/office1-after2.f39ea2ce.jpg";